module.exports = __webpack_public_path__ + "img/user115.44e9f53f.jpg";